export const queryKeys = {
  videoConstraints: ["video-constraints"],
  navigatorPermissions: (permission: PermissionName) => ["navigatorPermissions", permission],
  permissionStatusLoger: (permission: PermissionName) => ["log-permissions-status", permission],
  browserModel: (modelUrl: string) => ["browser-model", modelUrl],
} as const
